// This is what we expect passed back from the client to protect against xsrf.
const XSRF_HEADER = 'X-XSRF-TOKEN'

// This is what we use to track requests throughout the stack
const CORRELATION_ID = 'X-CID'

module.exports = {
  XSRF_HEADER,
  CORRELATION_ID,
}
